import React from "react";
import classnames from "classnames";
import {Button, Form} from "react-bootstrap";

const NoteForm = ({organizationName, affiliateMemberId, setNotes}) => {
  const [body, setBody] = React.useState("");
  const [errors, setErrors] = React.useState([]);

  const handleCreate = () => {
    $.ajax({
      url: `/organizations/${organizationName}/affiliate_members/${affiliateMemberId}/notes.json`,
      method: "POST",
      data: {
        note: {
          body: body,
        }
      },
      success: (data) => {
        setNotes((notes) => [data, ...notes]);
        setBody("");
        setErrors([])
      }
    });
  }

  return <Form className={"mb-4 pt-2 border-bottom pb-4"}>
    <Form.Group className={"col-12"} controlId="noteBody">
      <Form.Control
        as="textarea"
        placeholder="Enter notes here..."
        style={{minHeight: '5rem'}}
        value={body}
        onChange={(e) => setBody(e.target.value)}/>
    </Form.Group>
    {!!errors.length && <div className="col-12">
      <div className="alert alert-danger">
        <ul className="mb-0">
          {errors.map((error, index) => <li key={index}>{error}</li>)}
        </ul>
      </div>
    </div>}
    <div className="col-12 d-flex justify-content-end">
      <Button
        className={"mb-4"}
        size="sm"
        onClick={() => {
          if (body === "") {
            setErrors(["Note cannot be empty"]);
          } else {
            handleCreate();
          }
        }}>
        Save
      </Button>
    </div>
  </Form>;
}

export default NoteForm;
